// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file gdx/gateway/web/payment/v2/subscription.proto (package gdx.gateway.web.payment.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Duration, Message, proto3, Timestamp } from "@bufbuild/protobuf";

/**
 * Enumerates possible subscription governing modes.
 *
 * @generated from enum gdx.gateway.web.payment.v2.Governor
 */
export enum Governor {
  /**
   * @generated from enum value: GOVERNOR_INVALID = 0;
   */
  INVALID = 0,

  /**
   * @generated from enum value: GOVERNOR_INTERNAL = 1;
   */
  INTERNAL = 1,

  /**
   * @generated from enum value: GOVERNOR_SOLID = 4;
   */
  SOLID = 4,
}
// Retrieve enum metadata with: proto3.getEnumType(Governor)
proto3.util.setEnumType(Governor, "gdx.gateway.web.payment.v2.Governor", [
  { no: 0, name: "GOVERNOR_INVALID" },
  { no: 1, name: "GOVERNOR_INTERNAL" },
  { no: 4, name: "GOVERNOR_SOLID" },
]);

/**
 * Enumerates subscription types.
 *
 * @generated from enum gdx.gateway.web.payment.v2.SubType
 */
export enum SubType {
  /**
   * @generated from enum value: SUB_TYPE_INVALID = 0;
   */
  INVALID = 0,

  /**
   * @generated from enum value: SUB_TYPE_DEFAULT = 1;
   */
  DEFAULT = 1,

  /**
   * @generated from enum value: SUB_TYPE_TRIAL = 2;
   */
  TRIAL = 2,

  /**
   * @generated from enum value: SUB_TYPE_DISCOUNT = 3;
   */
  DISCOUNT = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(SubType)
proto3.util.setEnumType(SubType, "gdx.gateway.web.payment.v2.SubType", [
  { no: 0, name: "SUB_TYPE_INVALID" },
  { no: 1, name: "SUB_TYPE_DEFAULT" },
  { no: 2, name: "SUB_TYPE_TRIAL" },
  { no: 3, name: "SUB_TYPE_DISCOUNT" },
]);

/**
 * What subscription type is active now.
 *
 * @generated from enum gdx.gateway.web.payment.v2.Tier
 */
export enum Tier {
  /**
   * @generated from enum value: TIER_INVALID = 0;
   */
  INVALID = 0,

  /**
   * @generated from enum value: TIER_FREE = 1;
   */
  FREE = 1,

  /**
   * @generated from enum value: TIER_PLUS = 2;
   */
  PLUS = 2,

  /**
   * @generated from enum value: TIER_PREMIUM = 3;
   */
  PREMIUM = 3,

  /**
   * @generated from enum value: TIER_GOLD = 4;
   */
  GOLD = 4,

  /**
   * @generated from enum value: TIER_UNLIMITED = 5;
   */
  UNLIMITED = 5,
}
// Retrieve enum metadata with: proto3.getEnumType(Tier)
proto3.util.setEnumType(Tier, "gdx.gateway.web.payment.v2.Tier", [
  { no: 0, name: "TIER_INVALID" },
  { no: 1, name: "TIER_FREE" },
  { no: 2, name: "TIER_PLUS" },
  { no: 3, name: "TIER_PREMIUM" },
  { no: 4, name: "TIER_GOLD" },
  { no: 5, name: "TIER_UNLIMITED" },
]);

/**
 * Enumerates possible sources for subscription event initiator.
 *
 * @generated from enum gdx.gateway.web.payment.v2.CommandSourceType
 */
export enum CommandSourceType {
  /**
   * @generated from enum value: COMMAND_SOURCE_TYPE_INVALID = 0;
   */
  INVALID = 0,

  /**
   * @generated from enum value: COMMAND_SOURCE_TYPE_USER = 1;
   */
  USER = 1,

  /**
   * @generated from enum value: COMMAND_SOURCE_TYPE_AUTO = 2;
   */
  AUTO = 2,

  /**
   * @generated from enum value: COMMAND_SOURCE_TYPE_ADMIN = 3;
   */
  ADMIN = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(CommandSourceType)
proto3.util.setEnumType(CommandSourceType, "gdx.gateway.web.payment.v2.CommandSourceType", [
  { no: 0, name: "COMMAND_SOURCE_TYPE_INVALID" },
  { no: 1, name: "COMMAND_SOURCE_TYPE_USER" },
  { no: 2, name: "COMMAND_SOURCE_TYPE_AUTO" },
  { no: 3, name: "COMMAND_SOURCE_TYPE_ADMIN" },
]);

/**
 * Describes subscription message.
 *
 * @generated from message gdx.gateway.web.payment.v2.Subscription
 */
export class Subscription extends Message<Subscription> {
  /**
   * @generated from field: string package_id = 2;
   */
  packageId = "";

  /**
   * @generated from field: string promotion_id = 14;
   */
  promotionId = "";

  /**
   * @generated from field: string next_package_id = 5;
   */
  nextPackageId = "";

  /**
   * @generated from field: gdx.gateway.web.payment.v2.Governor governor = 7;
   */
  governor = Governor.INVALID;

  /**
   * @generated from oneof gdx.gateway.web.payment.v2.Subscription.state
   */
  state: {
    /**
     * @generated from field: gdx.gateway.web.payment.v2.SubscriptionStateActive active = 8;
     */
    value: SubscriptionStateActive;
    case: "active";
  } | {
    /**
     * @generated from field: gdx.gateway.web.payment.v2.SubscriptionStatePending pending = 9;
     */
    value: SubscriptionStatePending;
    case: "pending";
  } | {
    /**
     * @generated from field: gdx.gateway.web.payment.v2.SubscriptionStateInactive inactive = 10;
     */
    value: SubscriptionStateInactive;
    case: "inactive";
  } | {
    /**
     * @generated from field: gdx.gateway.web.payment.v2.SubscriptionStateSuspended suspended = 11;
     */
    value: SubscriptionStateSuspended;
    case: "suspended";
  } | { case: undefined; value?: undefined } = { case: undefined };

  /**
   * @generated from field: bool is_active = 1 [deprecated = true];
   * @deprecated
   */
  isActive = false;

  /**
   * @generated from field: google.protobuf.Timestamp expires_time = 3 [deprecated = true];
   * @deprecated
   */
  expiresTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Duration expires_duration = 4 [deprecated = true];
   * @deprecated
   */
  expiresDuration?: Duration;

  /**
   * @generated from field: google.protobuf.Timestamp next_charge_time = 6 [deprecated = true];
   * @deprecated
   */
  nextChargeTime?: Timestamp;

  /**
   * @generated from field: gdx.gateway.web.payment.v2.Tier tier = 12;
   */
  tier = Tier.INVALID;

  /**
   * @generated from field: gdx.gateway.web.payment.v2.SubType sub_type = 13;
   */
  subType = SubType.INVALID;

  constructor(data?: PartialMessage<Subscription>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.Subscription";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 2, name: "package_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "promotion_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "next_package_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "governor", kind: "enum", T: proto3.getEnumType(Governor) },
    { no: 8, name: "active", kind: "message", T: SubscriptionStateActive, oneof: "state" },
    { no: 9, name: "pending", kind: "message", T: SubscriptionStatePending, oneof: "state" },
    { no: 10, name: "inactive", kind: "message", T: SubscriptionStateInactive, oneof: "state" },
    { no: 11, name: "suspended", kind: "message", T: SubscriptionStateSuspended, oneof: "state" },
    { no: 1, name: "is_active", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "expires_time", kind: "message", T: Timestamp },
    { no: 4, name: "expires_duration", kind: "message", T: Duration },
    { no: 6, name: "next_charge_time", kind: "message", T: Timestamp },
    { no: 12, name: "tier", kind: "enum", T: proto3.getEnumType(Tier) },
    { no: 13, name: "sub_type", kind: "enum", T: proto3.getEnumType(SubType) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Subscription {
    return new Subscription().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Subscription {
    return new Subscription().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Subscription {
    return new Subscription().fromJsonString(jsonString, options);
  }

  static equals(a: Subscription | PlainMessage<Subscription> | undefined, b: Subscription | PlainMessage<Subscription> | undefined): boolean {
    return proto3.util.equals(Subscription, a, b);
  }
}

/**
 * Subscription state active.
 *
 * @generated from message gdx.gateway.web.payment.v2.SubscriptionStateActive
 */
export class SubscriptionStateActive extends Message<SubscriptionStateActive> {
  /**
   * @generated from field: google.protobuf.Timestamp expires_time = 1;
   */
  expiresTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Duration expires_duration = 2;
   */
  expiresDuration?: Duration;

  /**
   * @generated from field: google.protobuf.Timestamp next_charge_time = 3;
   */
  nextChargeTime?: Timestamp;

  constructor(data?: PartialMessage<SubscriptionStateActive>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.SubscriptionStateActive";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "expires_time", kind: "message", T: Timestamp },
    { no: 2, name: "expires_duration", kind: "message", T: Duration },
    { no: 3, name: "next_charge_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SubscriptionStateActive {
    return new SubscriptionStateActive().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SubscriptionStateActive {
    return new SubscriptionStateActive().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SubscriptionStateActive {
    return new SubscriptionStateActive().fromJsonString(jsonString, options);
  }

  static equals(a: SubscriptionStateActive | PlainMessage<SubscriptionStateActive> | undefined, b: SubscriptionStateActive | PlainMessage<SubscriptionStateActive> | undefined): boolean {
    return proto3.util.equals(SubscriptionStateActive, a, b);
  }
}

/**
 * Subscription state pending.
 *
 * @generated from message gdx.gateway.web.payment.v2.SubscriptionStatePending
 */
export class SubscriptionStatePending extends Message<SubscriptionStatePending> {
  /**
   * @generated from field: google.protobuf.Timestamp expires_time = 1;
   */
  expiresTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Duration expires_duration = 2;
   */
  expiresDuration?: Duration;

  /**
   * @generated from field: google.protobuf.Timestamp next_retry_time = 3;
   */
  nextRetryTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Duration next_retry_duration = 4;
   */
  nextRetryDuration?: Duration;

  /**
   * @generated from field: string last_failed_order_id = 5;
   */
  lastFailedOrderId = "";

  constructor(data?: PartialMessage<SubscriptionStatePending>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.SubscriptionStatePending";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "expires_time", kind: "message", T: Timestamp },
    { no: 2, name: "expires_duration", kind: "message", T: Duration },
    { no: 3, name: "next_retry_time", kind: "message", T: Timestamp },
    { no: 4, name: "next_retry_duration", kind: "message", T: Duration },
    { no: 5, name: "last_failed_order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SubscriptionStatePending {
    return new SubscriptionStatePending().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SubscriptionStatePending {
    return new SubscriptionStatePending().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SubscriptionStatePending {
    return new SubscriptionStatePending().fromJsonString(jsonString, options);
  }

  static equals(a: SubscriptionStatePending | PlainMessage<SubscriptionStatePending> | undefined, b: SubscriptionStatePending | PlainMessage<SubscriptionStatePending> | undefined): boolean {
    return proto3.util.equals(SubscriptionStatePending, a, b);
  }
}

/**
 * Subscription state inactive.
 *
 * @generated from message gdx.gateway.web.payment.v2.SubscriptionStateInactive
 */
export class SubscriptionStateInactive extends Message<SubscriptionStateInactive> {
  /**
   * @generated from field: google.protobuf.Timestamp expires_time = 1;
   */
  expiresTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Duration expires_duration = 2;
   */
  expiresDuration?: Duration;

  constructor(data?: PartialMessage<SubscriptionStateInactive>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.SubscriptionStateInactive";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "expires_time", kind: "message", T: Timestamp },
    { no: 2, name: "expires_duration", kind: "message", T: Duration },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SubscriptionStateInactive {
    return new SubscriptionStateInactive().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SubscriptionStateInactive {
    return new SubscriptionStateInactive().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SubscriptionStateInactive {
    return new SubscriptionStateInactive().fromJsonString(jsonString, options);
  }

  static equals(a: SubscriptionStateInactive | PlainMessage<SubscriptionStateInactive> | undefined, b: SubscriptionStateInactive | PlainMessage<SubscriptionStateInactive> | undefined): boolean {
    return proto3.util.equals(SubscriptionStateInactive, a, b);
  }
}

/**
 * Subscription state suspended.
 *
 * @generated from message gdx.gateway.web.payment.v2.SubscriptionStateSuspended
 */
export class SubscriptionStateSuspended extends Message<SubscriptionStateSuspended> {
  /**
   * @generated from field: google.protobuf.Timestamp expires_time = 1;
   */
  expiresTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Duration expires_duration = 2;
   */
  expiresDuration?: Duration;

  /**
   * @generated from field: google.protobuf.Timestamp suspended_until_time = 3;
   */
  suspendedUntilTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Duration suspended_until_duration = 4;
   */
  suspendedUntilDuration?: Duration;

  /**
   * @generated from field: google.protobuf.Timestamp suspended_on_time = 5;
   */
  suspendedOnTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Duration suspended_on_duration = 6;
   */
  suspendedOnDuration?: Duration;

  constructor(data?: PartialMessage<SubscriptionStateSuspended>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.payment.v2.SubscriptionStateSuspended";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "expires_time", kind: "message", T: Timestamp },
    { no: 2, name: "expires_duration", kind: "message", T: Duration },
    { no: 3, name: "suspended_until_time", kind: "message", T: Timestamp },
    { no: 4, name: "suspended_until_duration", kind: "message", T: Duration },
    { no: 5, name: "suspended_on_time", kind: "message", T: Timestamp },
    { no: 6, name: "suspended_on_duration", kind: "message", T: Duration },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SubscriptionStateSuspended {
    return new SubscriptionStateSuspended().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SubscriptionStateSuspended {
    return new SubscriptionStateSuspended().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SubscriptionStateSuspended {
    return new SubscriptionStateSuspended().fromJsonString(jsonString, options);
  }

  static equals(a: SubscriptionStateSuspended | PlainMessage<SubscriptionStateSuspended> | undefined, b: SubscriptionStateSuspended | PlainMessage<SubscriptionStateSuspended> | undefined): boolean {
    return proto3.util.equals(SubscriptionStateSuspended, a, b);
  }
}

